import type { FC, ReactElement } from 'react';

import { useAudioTrigger } from '../../../../controllers/audioController/hooks';
import { useIsLobbyButtonHiddenConnected } from '../../../../hooks/useIsLobbyButtonHiddenConnected';
import { useShouldStayConnected } from '../../../../hooks/useShouldStayConnected';
import { useActiveDialogCleaner } from '../../../../store/actions/useActiveDialogCleaner';
import { useCoreDispatch } from '../../../../store/CoreStore';
import { useConfigSlice } from '../../../../store/slices/config/selectors';
import { useGameStateSlice } from '../../../../store/slices/game/selectors';
import { headerActions } from '../../../../store/slices/header/slice';
import { popupActions } from '../../../../store/slices/popup/slice';
import { PopupType } from '../../../popup/types';

import { LobbyControlPlain } from './LobbyControlPlain';

export const LobbyControlConnected: FC = (): ReactElement | null => {
  const dispatch = useCoreDispatch();
  const audioTrigger = useAudioTrigger();
  const shouldStayAtTable = useShouldStayConnected();
  const isLobbyButtonHidden = useIsLobbyButtonHiddenConnected();
  const tableConfig = useConfigSlice.tableConfig();
  const hideUI = useGameStateSlice.hideUI();
  const cleanDialogs = useActiveDialogCleaner();

  const lobbyButtonClick = (): void => {
    if (hideUI) {
      cleanDialogs();
    }
    dispatch(
      shouldStayAtTable
        ? popupActions.pushPopup(PopupType.DontLeaveRoundInProgress)
        : headerActions.setMiniLobbyOpen(true)
    );
    audioTrigger.play({ name: 'menuClick' });
  };

  return isLobbyButtonHidden ? null : (
    <LobbyControlPlain onClick={lobbyButtonClick} branding={Boolean(tableConfig?.showPPBranding)} />
  );
};
